import { ref } from "vue"
import type { PageError } from "./usePageData"

const pageErrors = ref<Record<string, boolean>>({})

export function usePageErrors() {
  const setErrors = (errorsData: PageError[]) => {
    if(!!errorsData.length){
      errorsData.forEach((err) => {
        if (!!err && err.error) pageErrors.value[err.id] = err.error
        else delete pageErrors.value[err.id]
      })
    }

  }

  return { pageErrors, setErrors }
}
